import React from 'react';
import { TextField, useTheme } from '@mui/material';

const CustomTextField = ({ label, name, value, formik, helperText, ...props }) => {
  const theme = useTheme(); // Use theme within the component directly
  const hasError = formik.touched[name] && Boolean(formik.errors[name]);

  return (
    <TextField
      label={label}
      name={name}
      value={value}
      onChange={formik.handleChange} // Use formik handleChange to trigger validation on change
      onBlur={formik.handleBlur} // Use formik handleBlur to mark the field as touched
      fullWidth
      error={hasError}
      helperText={
        hasError
          ? <span style={{ color: theme.palette.error.main }}>{formik.errors[name]}</span>
          : !value && <span style={{ color: theme.palette.success.text }}>{helperText}</span> // Show helper text only if the field is empty
      }
      sx={{
        padding: theme.spacing(1), // Padding for better readability
      }}
      InputLabelProps={{
        style: { color: theme.palette.success.text }, // Label color
      }}
      InputProps={{
        style: { color: theme.palette.success.text, backgroundColor: "transparent" }, // Input text color and remove background
      }}
      {...props}
    />
  );
};

export default CustomTextField;
